// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { BigButton } from 'jsw';

/* SMB specific JavaScript classes */

/**
 * @deprecated
 */
export const ToolButton = BigButton;
